/**
 * @file This file registers commonly used icons globally.
 */
/*
 * Import the interface for an IconDefinition, and the library of all icons,
 * which we can add our icons to.
 */
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPaste } from '@fortawesome/free-regular-svg-icons/faPaste';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlass';
import { faPencil } from '@fortawesome/free-solid-svg-icons/faPencil';
import { faPercent } from '@fortawesome/free-solid-svg-icons/faPercent';
import { faPlus as fasPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faReply } from '@fortawesome/free-solid-svg-icons/faReply';
import { faRotate } from '@fortawesome/free-solid-svg-icons/faRotate';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons/faTriangleExclamation';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';
import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers';
import { faGear } from '@fortawesome/pro-regular-svg-icons/faGear';
import { faPlus as farPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
/** Import font awesome icon component, so we can wrap it. */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vue from 'vue';
import Icon from '@/components/Icon';
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('icon', Icon);
/** Defining our custom icons for clean usage elsewhere, as IconDefinition. */
export const CgTilde = {
    prefix: 'fas',
    iconName: 'tilde',
    icon: [
        24,
        24,
        [],
        '',
        'M2,15C2,15 2,9 8,9C12,9 12.5,12.5 15.5,12.5C19.5,12.5 19.5,9 19.5,9H22C22,9 22,15 16,15C12,15 10.5,11.5 8.5,11.5C4.5,11.5 4.5,15 4.5,15H2',
    ],
};
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const CgSubmissions = {
    prefix: 'fas',
    // @ts-expect-error: This is a new icon so the name is not known yet.
    iconName: 'submissions',
    icon: [
        384,
        469,
        [],
        '',
        'm 172.50781,21.150391 c -23.5575,0 -42.65039,19.092884 -42.65039,42.65039 v 21.597657 h -23.15625 c -23.557488,0 -42.652342,19.094852 -42.652342,42.652342 v 20.5 H 44.558594 c -23.557487,0 -42.6503909,19.09291 -42.6503909,42.65039 v 255.90039 c 0,23.52416 19.0929039,42.65039 42.6503909,42.65039 H 215.16016 c 23.52416,0 42.64843,-19.12623 42.64843,-42.65039 v -20.5 h 19.49414 c 23.52417,0 42.64844,-19.12623 42.64844,-42.65039 v -21.59961 h 23.15821 c 23.52418,0 42.65039,-19.12425 42.65039,-42.64844 V 124.11133 c 0,-11.32893 -4.466,-22.1242 -12.46289,-30.121096 L 312.91992,33.646484 C 304.92303,25.644927 294.12776,21.150391 282.79883,21.150391 Z m 0,31.988281 h 106.625 v 53.312498 c 0,11.79542 9.53077,21.32617 21.32617,21.32617 h 53.3125 v 191.92578 c 0,5.86439 -4.79772,10.66211 -10.6621,10.66211 H 172.50781 c -5.89104,0 -10.66211,-4.79772 -10.66211,-10.66211 V 278 63.800781 c 0,-5.891044 4.77107,-10.662109 10.66211,-10.662109 z m -65.80664,64.248048 h 23.15625 v 202.3164 c 0,23.52419 19.09289,42.64844 42.65039,42.64844 h 115.45703 v 21.59961 c 0,5.86438 -4.79773,10.66211 -10.66211,10.66211 H 106.70117 c -5.89104,0 -10.664061,-4.79773 -10.664061,-10.66211 V 128.05078 c 0,-5.89104 4.773021,-10.66406 10.664061,-10.66406 z m -62.142576,63.15234 h 19.490234 v 203.41211 c 0,23.52416 19.094854,42.65039 42.652342,42.65039 h 119.1211 v 20.5 c 0,5.86438 -4.79774,10.66211 -10.66211,10.66211 H 44.558594 c -5.891044,0 -10.66211,-4.79773 -10.66211,-10.66211 V 191.20117 c 0,-5.89104 4.771066,-10.66211 10.66211,-10.66211 z',
    ],
};
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const CgSnippets = {
    prefix: 'fas',
    // @ts-expect-error: This is a new icon so the name is not known yet.
    iconName: 'snippets',
    icon: [
        1536,
        1350,
        [],
        '',
        'M1442 98c24 8 53 29 66 42 10 10 28 34 28 68v992c0 27-9 49-28 68s-42 32-68 28l-336-46-336 100-512-142-130 76c-11 6-63 19-98-16a92 92 0 01-28-68V216c0-27 9-49 28-68s39-31 68-50L256 0l513 138 337-100zM256 138l-116 88s-12 5-12 24v918l128-88 512 142 336-100 304 46V242c0-13-12-16-12-16l-290-46-337 100-513-142m128 388c0-9 3-17 9-23s14-9 23-9h704c9 0 17 3 23 9s9 14 9 23v64c0 9-3 17-9 23s-14 9-23 9H416c-9 0-17-3-23-9s-9-14-9-23zm736 224c9 0 17 3 23 9s9 14 9 23v64c0 9-3 17-9 23s-14 9-23 9H416c-9 0-17-3-23-9s-9-14-9-23v-64c0-9 3-17 9-23s14-9 23-9z',
    ],
};
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const CgDiff = {
    prefix: 'fas',
    // @ts-expect-error: This is a new icon so the name is not known yet.
    iconName: 'diff',
    icon: [
        896,
        1024,
        [],
        '',
        'M448 256H320v128H192v128h128v128h128V512h128V384H448V256zM192 896h384V768H192V896zM640 0H128v64h480l224 224v608h64V256L640 0zM0 128v896h768V320L576 128H0zM704 960H64V192h480l160 160V960z',
    ],
};
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const CgProgress = {
    prefix: 'fas',
    // @ts-expect-error: This is a new icon so the name is not known yet.
    iconName: 'progress',
    icon: [
        1894,
        1894,
        [],
        '',
        'm 448,1088 c -53.3333,0 -98.6667,-18.6667 -136,-56 -37.3333,-37.3333 -56,-82.6667 -56,-136 0,-53.3333 18.6667,-98.6667 56,-136 37.3333,-37.3333 82.6667,-56 136,-56 40,0 76.6667,11.6667 110,35 33.3333,23.3333 57,54.3333 71,93 h 651 V 960 H 629 c -14,38.6667 -37.6667,69.6667 -71,93 -33.3333,23.3333 -70,35 -110,35 z m 0,128 c 51.3333,0 99.3333,-11.3333 144,-34 44.6667,-22.6667 82,-54 112,-94 h 768 c 53.3333,0 98.6667,-18.6667 136,-56 37.3333,-37.3333 56,-82.6667 56,-136 0,-53.3333 -18.6667,-98.6667 -56,-136 -37.3333,-37.3333 -82.6667,-56 -136,-56 H 704 C 674,664 636.6667,632.6667 592,610 547.3333,587.3333 499.3333,576 448,576 359.3333,576 283.8333,607.1667 221.5,669.5 159.1667,731.8333 128,807.3333 128,896 c 0,88.6667 31.1667,164.1667 93.5,226.5 62.3333,62.3333 137.8333,93.5 226.5,93.5 z m 0,128 C 324.6667,1344 219.1667,1300.1667 131.5,1212.5 43.8333,1124.8333 0,1019.3333 0,896 0,772.6667 43.8333,667.1667 131.5,579.5 219.1667,491.83333 324.6667,448 448,448 c 121.3333,0 225.6667,42.66667 313,128 h 711 c 88.6667,0 164.1667,31.1667 226.5,93.5 62.3333,62.3333 93.5,137.8333 93.5,226.5 0,88.6667 -31.1667,164.1667 -93.5,226.5 -62.3333,62.3333 -137.8333,93.5 -226.5,93.5 H 761 c -87.3333,85.3333 -191.6667,128 -313,128 z',
    ],
};
library.add(CgTilde, CgSubmissions, CgSnippets, CgDiff, CgProgress, faPaste, faArrowRight, faBars, faBook, faEnvelope, faEye, faEyeSlash, faMagnifyingGlass, faRotate, faArrowLeft, faLock, faPercent, faCheck, faChevronDown, faPencil, farPlus, fasPlus, faReply, faTrash, faTriangleExclamation, faXmark, faUsers, faGear);
